import React, { createContext, useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { useAuth } from "../../auth/AuthContext";

// Context so nested pages (e.g. RunDetail) can inject engine metadata into
// the top bar chip.
const EngineMetaContext = createContext({
  setEngineMeta: () => {},
  engineMeta: null,
});

export function useEngineMeta() {
  return useContext(EngineMetaContext);
}

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [engineMeta, setEngineMeta] = useState(null);
  const { expiredBanner, clearExpiredBanner } = useAuth();

  return (
    <EngineMetaContext.Provider value={{ engineMeta, setEngineMeta }}>
      <div className="min-h-screen bg-slate-50 text-slate-900">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="lg:pl-64">
          <TopBar
            onOpenSidebar={() => setSidebarOpen(true)}
            engineMeta={engineMeta}
          />
          {expiredBanner && (
            <div
              role="alert"
              data-testid="expired-banner"
              className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900"
            >
              <span>Your session expired. Please sign in again.</span>
              <button
                type="button"
                onClick={clearExpiredBanner}
                className="ml-3 text-amber-700 underline"
              >
                Dismiss
              </button>
            </div>
          )}
          <main className="p-4 sm:p-6 lg:p-8">
            <Outlet />
          </main>
        </div>
        {sidebarOpen && (
          <div
            className="fixed inset-0 z-30 bg-slate-900/40 lg:hidden"
            onClick={() => setSidebarOpen(false)}
            aria-hidden="true"
          />
        )}
      </div>
    </EngineMetaContext.Provider>
  );
}
